// extracted by mini-css-extract-plugin
export default {"addMessageForm":"SendMessageForm_addMessageForm__Acwpu","emojiContainer":"SendMessageForm_emojiContainer__L6QDj"};